/**
 * API 錯誤碼定義與訊息對應
 *
 * 錯誤碼規則：
 * - 5000-5099: RichMenu 相關錯誤
 */

// RichMenu 錯誤碼
export const RICHMENU_INVALID_START_TIME = 5001
export const RICHMENU_ALREADY_PUBLISHED = 5002
export const RICHMENU_DEFAULT_CONFLICT = 5003
export const RICHMENU_PUBLISH_FAILED = 5004
export const RICHMENU_SET_DEFAULT_FAILED = 5005
export const RICHMENU_NOT_BELONG_TO_MERCHANT = 5006
export const RICHMENU_SYNC_FAILED = 5007
export const RICHMENU_DELETE_FAILED = 5008
export const RICHMENU_UNPUBLISH_FAILED = 5009

/**
 * 錯誤碼對應的使用者友善訊息
 */
export const ERROR_MESSAGES = {
  [RICHMENU_INVALID_START_TIME]: '開始時間不可小於現在',
  [RICHMENU_ALREADY_PUBLISHED]: '圖文選單已經發布過了',
  [RICHMENU_DEFAULT_CONFLICT]: '設定為預設圖文選單時，與其他選單時段發生衝突',
  [RICHMENU_PUBLISH_FAILED]: '發布圖文選單失敗',
  [RICHMENU_SET_DEFAULT_FAILED]: '設定預設圖文選單失敗',
  [RICHMENU_NOT_BELONG_TO_MERCHANT]: '圖文選單不屬於當前商戶',
  [RICHMENU_SYNC_FAILED]: '從 LINE 同步圖文選單失敗',
  [RICHMENU_DELETE_FAILED]: '刪除圖文選單失敗',
  [RICHMENU_UNPUBLISH_FAILED]: '下架圖文選單失敗',
}

/**
 * 從 API 錯誤回應中取得使用者友善的錯誤訊息
 *
 * @param {Object} error - Axios 錯誤物件
 * @returns {Object} { message: string, context: Object|null }
 */
export function getErrorMessage(error) {
  const response = error?.response?.data

  // 檢查是否為結構化錯誤回應
  if (response?.error_code) {
    const errorCode = response.error_code
    const message = ERROR_MESSAGES[errorCode] || '發生未知錯誤'
    const context = response.context || null

    return { message, context, errorCode }
  }

  // 回退到傳統錯誤訊息
  const fallbackMessage = response?.message || error?.message || '發生未知錯誤'
  return { message: fallbackMessage, context: null, errorCode: null }
}

/**
 * 格式化衝突選單訊息
 *
 * @param {Array} conflictingMenus - 衝突的選單列表 [{id, title, start_at, end_at}, ...]
 * @returns {string}
 */
export function formatConflictMessage(conflictingMenus) {
  if (!conflictingMenus || conflictingMenus.length === 0) {
    return ''
  }

  const titles = conflictingMenus.map(menu => menu.title).join('、')
  return `與以下選單時段衝突：${titles}`
}
